import React, { lazy, Suspense } from "react";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import { useOperatorProfileContext } from "provider/OperatorProfileProvider";
import ShaerdSafariTourTabSekelton from "components/common/Skeleton/safariTabSekelton/ShaerdSafariTourTabSekelton";
import { useAuth } from "provider/AuthContext";
import GetQuoteForm from "components/common/GetQuoteForm";
import { Link, useParams } from "react-router-dom";

const ShaerdSafari = lazy(() => import("./sharesafari/ShaerdSafari"));
const OperaterPackage = lazy(() => import("./package/OperaterPackage"));
const Parks = lazy(() => import("./parks/Parks"));
const OperatorReview = lazy(() => import("./review/OperatorReview"));
const Contact = lazy(() => import("./contact/Contact"));

const SafariTourOperatorsDetails = React.memo(() => {
  const { slug } = useParams();
  const { isLoggedIn } = useAuth();
  const { loadingOpProfile, opSharedSafariLoading, activeTab, operatorParksOptions, operatorProfileDispatch } = useOperatorProfileContext();
  const handleTabClick = (tabname) => {
    operatorProfileDispatch({ type: "SET_PROFILE_ACTIVE_TAB", payload: tabname });
  }

  return (
    <>
      <Row
        className="pt-0 itenary_tabs justify-content-center position-relative bg-white"
        id="safari_tour_operator_container"
      >
        <Tab.Container activeKey={activeTab}>
          <Col xxl={12}>

            <Row>
              <Col
              
                lg={{ span: 12, offset: 0 }}
                xl={{ span: 9, offset: 1 }}
                xxl={{ span: 10, offset: 2 }}
                className="mt-2 position-relative safartabs "
              >
                <div className="overflow-auto w-100 hide-scrollbar px-md-3 px-sm-3 px-3">
                  <Nav className="nav-tabs slider_addmobile3 owl-theme d-flex gap-2 flex-nowrap">
                    <Nav.Item>
                      <Nav.Link eventKey="safaris" onClick={() => handleTabClick("safaris")}>Shaerd Safari</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="packages" onClick={() => handleTabClick("packages")}>Packages</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="parks" onClick={() => handleTabClick("parks")}>Parks</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="reviews" onClick={() => handleTabClick("reviews")}>Review</Nav.Link>
                    </Nav.Item>
                    {/* <Nav.Item>
                    <Nav.Link eventKey="contact" onClick={() => handleTabClick("contact")}>Contact</Nav.Link>
                  </Nav.Item>  */}
                  </Nav>
                </div>
              </Col>
            </Row>
          </Col>
          <div className="px-2 bg-section-wrapper " style={{ background: "#f5f5f5" }}>
            <Col xxl={8} xl={10} lg={12} className="mx-auto" style={{ background: "#f5f5f5" }}>
              <Row className="pt-3">
                <Col lg={8} md={12}>
                  <Tab.Content className="mt-0" >
                    <Tab.Pane eventKey="safaris" className="mt-0">
                      <Suspense fallback={<ShaerdSafariTourTabSekelton />}>
                        {opSharedSafariLoading ? <ShaerdSafariTourTabSekelton />
                          :
                          <ShaerdSafari />
                        }
                      </Suspense>
                    </Tab.Pane>
                    <Tab.Pane eventKey="packages" className="mt-0">
                      <Suspense fallback={<ShaerdSafariTourTabSekelton />}>
                        {loadingOpProfile ? <ShaerdSafariTourTabSekelton />
                          : <OperaterPackage />
                        }
                      </Suspense>

                    </Tab.Pane>
                    <Tab.Pane eventKey="parks" className="mt-0">
                      <Suspense fallback={<ShaerdSafariTourTabSekelton />}>
                        {loadingOpProfile ? <ShaerdSafariTourTabSekelton />
                          : <Parks />
                        }
                      </Suspense>

                    </Tab.Pane>
                    <Tab.Pane eventKey="reviews" className="mt-0">
                      <OperatorReview />
                    </Tab.Pane>
                    <Tab.Pane eventKey="contact" className="mt-0">
                      <Contact />
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
                <Col lg={4} md={12} className="margin_bottomfooter">
                  {isLoggedIn ?
                    <div className="px-3">
                      <GetQuoteForm title="Get a Free Quote" quotationFormNote='' reqUrl={`operator/${slug}/quotesrequest`} quoteRequestFrom={"opProfile"} parkDropDown={operatorParksOptions || []} accomDropDown={[]}/>
                    </div>
                    :

                    <Link
                      to={`/log-in?authclient=google&referrer=${encodeURIComponent(`/operator/${slug}/profile`)}`}
                      class="sign_intext ">
                      <div className="px-md-3 px-sm-3 px-xs-3">
                        <picture className="position-relative">
                          <source
                            srcSet={"/img/quote_req_big.png"}
                            media="(max-width:576px)"
                            type="image/png"
                            style={{ borderRadius: "10px" }}
                          />
                          <img
                            src="/img/quote_req_big.png"
                            className="d-block w-100 banner_search"
                            alt="banner"
                            type="image/png"
                            loading="lazy"
                            style={{ borderRadius: "10px" }}
                          />
                        </picture>
                      </div>
                    </Link>

                  }
                </Col>
              </Row>
            </Col>
          </div>
        </Tab.Container>
      </Row>
    </>
  );
})

export default SafariTourOperatorsDetails;
